import React from 'react';
import logoFull from '../../assets/branding/logo-full.png';
import logoMark from '../../assets/branding/logo-mark.png';

type BrandLogoProps = {
  variant?: 'full' | 'mark';
  alt?: string;
  className?: string;
  imgClassName?: string;
};

export function BrandLogo({
  variant = 'full',
  alt = variant === 'full' ? 'TallerAdmin' : 'Isotipo de TallerAdmin',
  className = '',
  imgClassName = '',
}: BrandLogoProps) {
  const src = variant === 'full' ? logoFull : logoMark;

  return (
    <div className={className}>
      <img
        src={src}
        alt={alt}
        className={['h-full w-full object-contain', imgClassName].filter(Boolean).join(' ')}
        loading="eager"
        decoding="async"
      />
    </div>
  );
}
